import { cn } from '@discover-lib/utils';

export type RestaurantListItemContainerProps = React.ComponentPropsWithoutRef<'li'>;

export default function RestaurantListItemContainer({
  className,
  ...props
}: RestaurantListItemContainerProps) {
  return <li className={cn('px-3 py-6 lg:pb-6 lg:pl-0 lg:pr-10 lg:pt-8', className)} {...props} />;
}
